export default {
  state: {
    id: undefined,
    name: undefined,
    slug: undefined,
    description: undefined,
    authentication_token: undefined,
    partner_id: undefined,
    inactive: true,
    created_at: undefined,
    updated_at: undefined,
    relationships: {}
  }
}



// WEBPACK FOOTER //
// ./src/stores/PartnerAppStore.js